import React from "react";

const PrivacyHeader = ({ sections }) => {
  return (
    <>
      <h1 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-2">
        Privacy Policy
      </h1>
      <h2 className="text-lg text-center text-gray-700 mb-8 font-semibold">
        of ORBITRA TECHNOLOGIES LLP
      </h2>
      <p className="text-base text-gray-700 mb-8 text-center">
        This Privacy Policy is meant to help you understand what information we
        collect, why we collect it, and how you can manage your information.
      </p>
      <nav className="flex flex-wrap justify-center gap-2 mb-10">
        {sections.map((section, idx) => (
          <a
            key={section.title}
            href={`#section-${idx}`}
            className="px-3 py-1 rounded text-indigo-700 hover:underline text-sm font-medium"
          >
            {section.title}
          </a>
        ))}
      </nav>
    </>
  );
};

export default PrivacyHeader;
